export default __webpack_public_path__ + "static/media/trash-restore.2942564f.svg";